import { Component, computed, inject, input } from '@angular/core';

import { ChartComponent } from '../../../components/charts/chart.component';
import { AssetAllocation } from '../../../domain/lti/investment-portfolio.domain';

import { AssetAllocationChartService, DisplayField } from './asset-allocation-chart.service';
import type Highcharts from 'highcharts';

@Component({
  selector: 'td-wb-lti-asset-allocation-pie-chart',
  template: '@if (options(); as opts) { <td-wb-chart [options]="opts" /> }',
  styleUrls: ['./asset-allocation-chart.scss'],
  imports: [
    ChartComponent
  ]
})
export class AssetAllocationChartComponent {
  private readonly assetAllocationChartService = inject(AssetAllocationChartService);

  readonly assetAllocations = input<Array<AssetAllocation>>(undefined);
  readonly displayField = input<DisplayField>(undefined);
  readonly size = input<number>(240);
  readonly innerSize = input<number | string>(undefined);
  readonly animation = input<boolean>(true);

  readonly options = computed<Highcharts.Options | undefined>(() => {
    const assetAllocations = this.assetAllocations();
    if (assetAllocations === undefined) { return undefined; }
    return this.assetAllocationChartService.createChartConfiguration(
      assetAllocations,
      this.displayField(),
      this.size(),
      this.innerSize(),
      this.animation());
  });
}
